import { Toast } from 'antd-mobile';
import { getFamilyRank, getRecommendList, bannerList, familyJoin, getJoinFamilyInfo } from '@/services/api';

const familyList = {
  namespace: 'familyRankList',
  state: {
    familyInfo: {},
  },
  reducers: {
    updateFamilyInfo(state, { payload }) {
      return {
        ...state,
        familyInfo: payload,
      };
    },
  },
  effects: {
    *getFamilyRank({ payload }, { call }) {
      const { error, data } = yield call(getFamilyRank, {
        ...payload,
      });
      if (error) {
        Toast.show({
          content: error,
        });
        return false;
      }
      return data;
    },
    *getRecommendList({ payload }, { call }) {
      const { error, data } = yield call(getRecommendList, {
        ...payload,
      });
      if (error) {
        Toast.show({
          content: error,
        });
        return false;
      }
      return data;
    },
    *getBannerList({ payload }, { call }) {
      const { error, data } = yield call(bannerList, {
        ...payload,
      });
      if (error) {
        Toast.show({
          content: error,
        });
        return false;
      }
      return data;
    },
    *familyJoin({ payload }, { call }) {
      const { error, data } = yield call(familyJoin, {
        ...payload,
      });
      if (error) {
        Toast.show({
          content: error,
        });
        return false;
      }
      return data;
    },
    *getJoinFamilyInfo({ payload }, { call, put }) {
      const { error, data } = yield call(getJoinFamilyInfo, {
        ...payload,
      });
      if (error) {
        Toast.show({
          content: error,
        });
        return false;
      }
      yield put({
        type: 'updateFamilyInfo',
        payload: data,
      });
      return data;
    }
  }
};

export default familyList;


